module.exports = {"buildVersion":"2.21.1-220622332","release":"2.21.1","buildDateTime":"Wed Jun 22 2022 11:04"}


//////////////////
// WEBPACK FOOTER
// ./src/metadata.json
// module id = 1854
// module chunks = 23